import React from "react";
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect,
} from "react-router-dom";
import Header from "../components/Header";
import { CSidebar } from "../components/Sidebar";

import { useAuth } from "../hooks/auth";
import getPermission from "../utils/getPermission";
import { Container, ContainerButton } from "../styles/global";

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  initialComponents?: boolean;
  component: React.ComponentType;
  permission?: string;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  initialComponents = false,
  component: Component,
  permission = '#',
  ...rest
}) => {
  const { login } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!login ? (
          initialComponents ? (
            <div
              style={{
                display: "flex",
                height: "100%",
                backgroundColor: "#ffffff",
              }}
            >
              <div style={{ height: "100%" }} className="lateralMenuContainer">
                {/* <div style={{position: 'fixed'}}> */}
                <CSidebar />
                {/* </div> */}
              </div>
              <div style={{ display: "block", width: "100%" }}>
                <Header />
                {permission == "Sem acesso" || permission == '' ? <Container style={{fontSize:"22px"}}>Você não tem permissão para acessar este módulo.</Container> :
                <Container>
                  <Component />
                </Container>
                }
              </div>
            </div>
          ) : (
            <div style={{margin:'0px'}}>
              {permission == "Sem acesso" ? <Container style={{fontSize:"22px"}}>Você não tem permissão para acessar este módulo.</Container> :
                <Container style={{margin:'0px'}}>
                  <Component />
                </Container>
                }
            </div>
          )
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? "/" : "/dashboard",
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
